function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_13132",
  width: 40,
  height: 40
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_68151",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "chili",
  d: "M27.54,28.926a4.658,4.658,0,0,0,.473-3.852,2.825,2.825,0,0,0-1.606-1.76c.505-.979,1.388-2.252,2.175-2.207a.63.63,0,0,0,.678-.6.643.643,0,0,0-.6-.678c-1.708-.109-2.943,1.971-3.462,3.026l-.525-.2a1.631,1.631,0,0,0-.845-.109,5.976,5.976,0,0,0-3.7,2.777,24.641,24.641,0,0,0-1.76,3.225c-.211.429-.416.857-.633,1.28a19.078,19.078,0,0,1-3.18,4.62,8.324,8.324,0,0,1-4.057,2.5.639.639,0,0,0-.512.589.65.65,0,0,0,.441.646,11.245,11.245,0,0,0,3.558.633,10.215,10.215,0,0,0,1.248-.083,9.9,9.9,0,0,0,2.06-.557C21.206,36.707,24.936,33.335,27.54,28.926Zm14.448-7.992a.643.643,0,0,1-.678.6c-.813-.058-1.683,1.228-2.182,2.207A2.839,2.839,0,0,1,40.74,25.5a4.7,4.7,0,0,1-.48,3.858c-2.6,4.408-6.334,7.78-10.237,9.252a9.469,9.469,0,0,1-2.06.55,8.99,8.99,0,0,1-1.241.083,11.415,11.415,0,0,1-3.564-.627.642.642,0,0,1-.435-.646.633.633,0,0,1,.505-.589,8.372,8.372,0,0,0,4.057-2.5,19.187,19.187,0,0,0,3.186-4.626c.211-.416.422-.845.627-1.273a23.952,23.952,0,0,1,1.766-3.225,5.978,5.978,0,0,1,3.692-2.783,1.734,1.734,0,0,1,.851.109l.525.2c.512-1.056,1.747-3.129,3.455-3.026A.647.647,0,0,1,41.988,20.935Z",
  transform: "translate(-5.988 -9.729)"
}));

function SvgSpices(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpices);
export default __webpack_public_path__ + "static/media/spices.f34cc6b6.svg";
export { ForwardRef as ReactComponent };